import clsx from 'clsx'

import DocumentDetailsHeader from './DocumentDetailsHeader'
import styles from './DocumentDetailsLayout.module.scss'
import { useAppDispatch, useAppSelector } from '../../../../../hooks'
import layoutStyles from '../../../../common/Templates/DefaultLayout/DefaultLayout.module.scss'
import Navigation from '../../../../common/Templates/DefaultLayout/Navigation/Navigation'
import { selectIsNavigationOpen, setNavigationOpen } from '../../../Other/api'

interface DetailsLayoutProps {
  children: React.ReactNode
  mainClassName?: string
}

const DocumentDetailsLayout = ({
  children,
  mainClassName,
}: DetailsLayoutProps): JSX.Element => {
  const dispatch = useAppDispatch()
  const navigationOpen = useAppSelector(selectIsNavigationOpen)
  const toggleNavigation = () => {
    dispatch(setNavigationOpen(!navigationOpen))
  }
  return (
    <div className={clsx(layoutStyles.root, layoutStyles.documentsRoots)}>
      <Navigation
        isCollapsed={!navigationOpen}
        onCollapseClick={toggleNavigation}
        className={layoutStyles.navigation}
      />
      <div className={layoutStyles.mainContainer}>
        <DocumentDetailsHeader />
        <main className={clsx(layoutStyles.main, styles.main, mainClassName)}>
          {children}
        </main>
      </div>
    </div>
  )
}

export default DocumentDetailsLayout
